import PodiumInfoStore from './podium-info-store';
import { extractPathIdentifier } from '../../utils/helpers/api-helpers';
import { COMMON_PAGE_PATHS } from '../../constans/url-constants';

let podiumInfoStore: PodiumInfoStore | null = null;

const getPodiumInfoStore = (): PodiumInfoStore => {
  if (podiumInfoStore == null) {
    podiumInfoStore = new PodiumInfoStore(extractPathIdentifier(COMMON_PAGE_PATHS.PRESENTATION));
  }

  return podiumInfoStore;
};

export { getPodiumInfoStore };
